import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import * as graphql from 'generated/graphql';
import HorizontalRule from 'packages/kakapo-ui-kit/components/common/HorizontalRule';
import PersonAvatar from 'packages/kakapo-ui-kit/components/users/PersonAvatar';
import { SubSectionTitle } from 'packages/kakapo-ui-kit/components/common/Headings';

const Row = styled(Flex)`
	cursor: pointer;
`;

export default function LearningEventAttendeeAwardItem({
	user,
	disabled,
	selected,
	onClick,
}: {
	user: graphql.User;
	disabled?: boolean;
	selected?: boolean;
	onClick?: () => void;
}) {
	return (
		<>
			<Row flexDirection="row" alignItems="center" my={2} onClick={() => !disabled && onClick?.()}>
				<Box ml={2} mr={3}>
					<Flex justifyContent="center" alignItems="center">
						<input
							type="checkbox"
							checked={selected || disabled}
							disabled={disabled}
							onChange={() => !disabled && onClick?.()}
						/>
					</Flex>
				</Box>
				<Box mr={3}>
					<PersonAvatar person={user} />
				</Box>
				<Box flexGrow={1}>
					<SubSectionTitle>
						{user.firstName} {user.lastName}
					</SubSectionTitle>
				</Box>
				<Box ml={3} mr={2}>
					<SubSectionTitle>{user.email}</SubSectionTitle>
				</Box>
			</Row>

			<HorizontalRule />
		</>
	);
}
